// import CostsChart from "./CostsChart";
import Queries from "../../queries/queries2";
import React from "react";
import ReportingContainer from "../Reporting/ReportingContainer";
import TaxReportChart from "./TaxReportChart";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

class TaxReportContainer extends ReportingContainer {
  render() {
    return (
      <ReportingContainer
        {...this.props}
        type={"TAXES"}
        // header={"ids_taxes"}
        header={"ids_reports"}
        query={Queries.getTaxesReportData}
        Chart={TaxReportChart}
        showChart={false}
        showData={true}
        showPeriodSelect={false}
        showRangeSelect={true}
        hideBudgetTypeSelect={true}
        hideReportsTypeSelect={false}
      />
    );
  }
}

export default withRouter(injectIntl(TaxReportContainer));
